//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function SelectDateVitamins() {

  return (

 
     <DateController
         category = "vitamins_nutrients"  
        />  
  );
}
